// extracted by mini-css-extract-plugin
export default {"header-container":"PickonSite_header-container__WUNqp","flex":"PickonSite_flex__Jgntk","order-btn":"PickonSite_order-btn__Uf-ug","table":"PickonSite_table__2brlx"};